import React, { useState } from "react";
import { FaWhatsapp, FaPhoneAlt, FaComments, FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";
import "./QuickContact.css";

const WHATSAPP_NUMBER = "905316085676";
const PHONE_NUMBER = "4445450";

export default function QuickContact() {
  const [open, setOpen] = useState(false);

  // ESC ile kapama ve dışarı tıklama için
  React.useEffect(() => {
    if (!open) return;
    const handleKey = (e) => { if (e.key === "Escape") setOpen(false); };
    const handleClick = (e) => {
      if (!e.target.closest(".quick-contact-fixed")) setOpen(false);
    };
    document.addEventListener("keydown", handleKey);
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.removeEventListener("mousedown", handleClick);
    };
  }, [open]);

  // Baloncuk efekti için
  const [animate, setAnimate] = useState(false);
  const handleMainBtnClick = () => {
    setOpen((v) => !v);
    setAnimate(true);
    setTimeout(() => setAnimate(false), 800);
  };

  return (
    <div className={`quick-contact-fixed${open ? " open" : ""}`}>
      <button
        className={`quick-contact-main-btn${open ? " active" : ""}${animate ? " animate" : ""}`}
        aria-label={open ? "Kapat" : "Bize Ulaşın"}
        aria-expanded={open}
        aria-haspopup="true"
        tabIndex={0}
        onClick={handleMainBtnClick}
      >
        <FaComments />
      </button>
      <div
        className="quick-contact-bubble"
        role="group"
        aria-label="İletişim seçenekleri"
      >
        <a
          href={`https://api.whatsapp.com/send/?phone=${WHATSAPP_NUMBER}&text=Bir+talebim+var+yard%C4%B1mc%C4%B1+olabilir+misiniz%3F&type=phone_number&`}
          target="_blank"
          rel="noopener noreferrer"
          className="quick-contact-btn whatsapp"
          aria-label="WhatsApp ile iletişim"
          tabIndex={open ? 0 : -1}
        >
          <FaWhatsapp />
        </a>
        <a
          href={`tel:${PHONE_NUMBER}`}
          className="quick-contact-btn phone"
          aria-label="Telefon ile ara"
          tabIndex={open ? 0 : -1}
        >
          <FaPhoneAlt />
        </a>
        <a
          href="mailto:info@serdivan.bel.tr"
          className="quick-contact-btn mail"
          aria-label="E-posta ile iletişim"
          tabIndex={open ? 0 : -1}
        >
          <FaEnvelope />
        </a>
        <a
          href="https://instagram.com/serdivanbelediyesi"
          target="_blank"
          rel="noopener noreferrer"
          className="quick-contact-btn instagram"
          aria-label="Instagram"
          tabIndex={open ? 0 : -1}
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.facebook.com/serdivanbld"
          target="_blank"
          rel="noopener noreferrer"
          className="quick-contact-btn facebook"
          aria-label="Facebook"
          tabIndex={open ? 0 : -1}
        >
          <FaFacebookF />
        </a>
      </div>
    </div>
  );
}